<template>
  <div
    class="pointPhone"
    :style="
      formConfig.backgroundImage
        ? `background-image: url(${formConfig.backgroundImage})`
        : ''
    "
  >
    <img
      src="https://cdn-image.yucrm.cn/images/dyAssets/images/preview/shop_top_point.png"
      style="width: 100%; position: sticky; top: 0"
    />
    <div
      class="point-content"
      style="
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 118px;
      "
    >
      <div class="tab-box" :style="{ color: `${formConfig.tabTextColor}` }">
        <div class="tab-item" :style="[activeIndex == 0 ? activeStyle : '']">
          竞拍中
        </div>
        <div class="tab-item" :style="[activeIndex == 1 ? activeStyle : '']">
          待开始
        </div>
        <div class="tab-item" :style="[activeIndex == 2 ? activeStyle : '']">
          已结束
        </div>
        <div class="tab-item" :style="[activeIndex == 3 ? activeStyle : '']">
          我的
        </div>
      </div>

      <div
        class="prize-container"
        :style="{
          background: `linear-gradient(180deg, ${formConfig.prizeBgColorTop} 0%, ${formConfig.prizeBgColorBottom} 100%)`,
        }"
      >
        <img :src="formConfig.dealSealImage" class="right-img" />
        <div class="container-box">
          <div style="font-size: 13px; color: #222222">竞拍已结束！</div>
          <img
            class="ad-img"
            src="https://cdn-image.yucrm.cn/images/dy/pointAuction/advertisementImage.png"
          />
          <div style="font-size: 15px; color: #222222">这里是奖品名称</div>
          <div style="font-size: 12px; color: #999999; margin-top: 12px">
            起拍价
            <span style="font-size: 21px; color: #ff2929; font-weight: bold"
              >3000</span
            >
            积分
          </div>
        </div>
        <div
          class="main-btn"
          :style="{
            color: `${formConfig.buttonTextColor}`,
            'background-image': `url(${formConfig.buttonBgImage})`,
          }"
        >
          去看看
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    formConfig: {
      type: Object,
      default: () => {},
    },
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      activeIndex: 2,
    };
  },
  computed: {
    activeStyle() {
      return {
        "background-color": `${this.formConfig.tabSelectedBgColor}`,
        color: `${this.formConfig.tabSelectedTextColor}`,
        "font-weight": "bold",
      };
    },
  },
  watch: {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.pointPhone {
  background-size: 100% auto;
  background-repeat: no-repeat;
  background-attachment: scroll;
  width: 375px;
  height: 715px;
  border-radius: 25px;
  position: relative;
  overflow: auto;
  border: 1px solid #eaeaea;
  &::-webkit-scrollbar {
    display: none; /* 对于 Chrome, Safari 和 Opera 隐藏滚动条 */
  }
  .point-content {
    .tab-box {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      padding: 4px;
      background-color: rgba(255, 255, 255, 0.3);
      width: 332px;
      border-radius: 25px;
      font-size: 15px;

      .tab-item {
        flex: 1;
        padding: 8px;
        text-align: center;
        border-radius: 25px;
      }
    }
    .prize-container {
      width: 275px;
      height: auto;
      border-radius: 15px;
      margin-top: 20px;
      padding: 9px;
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
      .container-box {
        background-size: 100% 100%;
        padding: 16px;
        background-image: url("https://cdn-image.yucrm.cn/images/dy/pointAuction/list_content_short_bg.png");
        .ad-img {
          border-radius: 12px;
          width: 225px;
          height: 225px;
          margin: 16px 0 13px 0;
        }
      }
      .main-btn {
        width: 221px;
        height: 39px;
        background-size: 100% 100%;
        margin-top: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .right-img {
        width: 65px;
        height: 65px;
        position: absolute;
        top: 4px;
        right: 12px;
      }
    }
  }
}
.phone-height {
  height: 480px;
}
</style>
